import * as React from "react";
import type { SVGProps } from "react";
const SvgBike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 4.5a1 1 0 1 0 0 2h1.73l.62 2.35-5.47 1.93L9.06 9h.44a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2h.36l1.13 2.44-.1.04A4 4 0 1 0 9.88 16h4.26A4 4 0 1 0 18 11h-.02l-1.32-5a2 2 0 0 0-1.93-1.5zm1.13 9.5a4 4 0 0 1 1.92-2.5l-.2-.71-5.13 1.8.65 1.41zm-6.4 0a2 2 0 1 0 0 2H6a1 1 0 1 1 0-2zm8.86-.42.44 1.67a1 1 0 0 0 1.94-.5l-.44-1.68a2 2 0 1 1-1.94.5Z"
    />
  </svg>
);
export default SvgBike;
